import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import { selectRawProductsArray } from '../../../../../modules/selectors';
import { useCartWidgetSuggestions } from '../../../../../modules/suggest/hooks';
import ProductSuggestionItem from './components/ProductSuggestionItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Suggestions() {
  const {
    __
  } = useTranslator();
  const products = useAppSelector(selectRawProductsArray);
  const {
    suggestions: allSuggestions
  } = useCartWidgetSuggestions();
  const suggestions = allSuggestions && allSuggestions.filter(suggestion => !(products && products.some(product => product.identifier === suggestion.suggestionId)));
  if (!suggestions || suggestions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Base, {
      tagName: "h4",
      size: "small",
      transform: "uppercase",
      paddingX: "small",
      marginY: "small",
      children: __('Suggested')
    }), suggestions.map(product => /*#__PURE__*/_jsx(Base, {
      paddingX: "small",
      paddingBottom: "xsmall",
      children: /*#__PURE__*/_jsx(ProductSuggestionItem, {
        product: product
      })
    }, `suggestion-${product.suggestionId}`))]
  });
}